import { AllieButton, AllieHeader, AllieImg, AllieText } from '@allie/app-ui-lib';
import React, { useContext } from 'react';
import { isMobile } from '../../helpers/utils';
import { AuthContext } from '../../context/AuthProvider';
import './ResetSuccess.scss';

interface ResetPasswordProps {
  id: number;
  modalTitle: string;
  modalBodyTitle: string;
  modalBodySubtitle: string;
  modalConfirm: string;
}

const namespace = 'reset-success';

export const ResetSuccess: React.FC<ResetPasswordProps> = ({
  id,
  modalTitle,
  modalBodyTitle,
  modalBodySubtitle,
  modalConfirm,
}) => {
  const { handleAfterLogin } = useContext(AuthContext);

  const onSubmit = async () => {
    handleAfterLogin(true, id, undefined, true);
  };

  return (
    <div className={`${namespace}${isMobile ? '-mobile' : ''}`}>
      <AllieHeader className={`${namespace}-header`}>
        <AllieText type="h3">{modalTitle}</AllieText>
      </AllieHeader>
      <AllieImg className={`${namespace}-gif`} src="assets/change-password-success.gif" />
      <div className={`${namespace}-body`}>
        <AllieText type="h4" color="neutral-50" weight={600}>
          {modalBodyTitle}
        </AllieText>
        <AllieText type="body1" color="neutral-50">
          {modalBodySubtitle}
        </AllieText>
      </div>
      <div className={`${namespace}-confirm`}>
        <AllieButton
          onClick={onSubmit}
          corner="rounded-edges"
          allieColor="primary"
          allieSize="small"
        >
          {modalConfirm}
        </AllieButton>
      </div>
    </div>
  );
};
